import client from "./client";

const getRoles = () => client.get("role/users");

export default { getRoles };
